class TagBanner extends HTMLElement {
  constructor() {
    super();

    // Get hide settings from data attributes
    this.hideDays = parseInt(this.dataset.hideDays) || 2;
    this.hideUntilLogin = this.dataset.hideUntilLogin === 'true';

    console.log('🏷️ TagBanner initialized:', {
      hideDays: this.hideDays,
      hideUntilLogin: this.hideUntilLogin,
      dataAttributes: {
        hideDays: this.dataset.hideDays,
        hideUntilLogin: this.dataset.hideUntilLogin
      }
    });

    // Set up logout detection if using login-based hiding
    if (this.hideUntilLogin) {
      TagBanner.setupLogoutDetection();
    }

    // On load, if banner is hidden, remove this element
    const isHidden = TagBanner.isBannerHidden(this.hideUntilLogin);
    console.log('🔍 Banner visibility check:', { isHidden, hideUntilLogin: this.hideUntilLogin });
    
    if (isHidden) {
      console.log('❌ Banner is hidden, removing element');
      this.remove();
      return;
    } else {
      console.log('✅ Banner is visible, showing element');
      this.classList.remove('hidden');
    }

    this.closeButton = this.querySelector('.banner__close');

    if (this.closeButton) {
      this.closeButton.addEventListener('click', this._onClose.bind(this));
      console.log('🔘 Close button found and event listener added');
    } else {
      console.warn('⚠️ Close button not found');
    }
  }

  _onClose(e) {
    e.preventDefault();
    
    console.log('🚪 Banner close button clicked');
    
    const now = Date.now();
    let value;
    
    if (this.hideUntilLogin) {
      // Hide until next logout - simple flag approach
      value = {
        value: true,
        hideUntilLogin: true,
        timestamp: now
      };
      console.log('🔐 Setting login-based hiding (until logout):', {
        value: value
      });
    } else {
      // Hide for specified number of days
      const expiry = now + this.hideDays * 24 * 60 * 60 * 1000;
      value = {
        value: true,
        expiry: expiry,
        hideUntilLogin: false
      };
      console.log('⏰ Setting time-based hiding:', {
        hideDays: this.hideDays,
        expiry: new Date(expiry).toISOString(),
        value: value
      });
    }
    
    localStorage.setItem('is_banner_hidden', JSON.stringify(value));
    console.log('💾 Banner hidden state saved to localStorage');
    this.remove();
  }

  static isBannerHidden(hideUntilLogin = false) {
    const item = localStorage.getItem('is_banner_hidden');
    console.log('🔍 Checking if banner is hidden:', { 
      hasLocalStorageItem: !!item,
      hideUntilLogin: hideUntilLogin,
      rawItem: item 
    });
    
    if (!item) {
      console.log('📭 No localStorage item found, banner should be visible');
      return false;
    }
    
    try {
      const data = JSON.parse(item);
      console.log('📊 Parsed localStorage data:', data);
      
      if (data.hideUntilLogin) {
        // For login-based hiding, check if logout has occurred
        // The banner will be shown again after logout (handled by setupLogoutDetection)
        console.log('🔐 Login-based hiding check - banner hidden until logout');
        return !!data.value;
      } else {
        // Time-based hiding
        const now = Date.now();
        const isExpired = data.expiry && now > data.expiry;
        console.log('⏰ Time-based hiding check:', {
          expiry: data.expiry ? new Date(data.expiry).toISOString() : 'none',
          now: new Date(now).toISOString(),
          isExpired: isExpired
        });
        
        if (isExpired) {
          console.log('⏰ Expiry time reached, clearing hidden state and showing banner');
          localStorage.removeItem('is_banner_hidden');
          return false;
        }
        console.log('⏳ Still within hiding period, banner remains hidden');
        return !!data.value;
      }
    } catch (e) {
      console.error('❌ Error parsing localStorage data:', e);
      localStorage.removeItem('is_banner_hidden');
      return false;
    }
  }

  static setupLogoutDetection() {
    // Only set up once
    if (TagBanner.logoutDetectionSetup) {
      return;
    }
    TagBanner.logoutDetectionSetup = true;

    console.log('🔍 Setting up logout detection');

    // Method 1: Listen for clicks on logout links
    document.addEventListener('click', function(e) {
      const target = e.target.closest('a[href*="account/logout"]');
      if (target) {
        console.log('🚪 Logout link clicked, clearing banner state');
        TagBanner.clearBannerState();
      }
    });

    // Method 2: Listen for navigation to logout URL
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;

    history.pushState = function() {
      originalPushState.apply(history, arguments);
      TagBanner.checkForLogoutNavigation();
    };

    history.replaceState = function() {
      originalReplaceState.apply(history, arguments);
      TagBanner.checkForLogoutNavigation();
    };

    // Method 3: Listen for beforeunload to catch direct navigation
    window.addEventListener('beforeunload', function() {
      if (window.location.href.includes('account/logout')) {
        console.log('🚪 Navigating to logout URL, clearing banner state');
        TagBanner.clearBannerState();
      }
    });

    console.log('✅ Logout detection setup complete');
  }

  static checkForLogoutNavigation() {
    if (window.location.href.includes('account/logout')) {
      console.log('🚪 Navigation to logout URL detected, clearing banner state');
      TagBanner.clearBannerState();
    }
  }

  static clearBannerState() {
    localStorage.removeItem('is_banner_hidden');
    console.log('🧹 Banner state cleared due to logout');
  }
}

customElements.define('tag-banner', TagBanner);

// Utility function for testing - clear banner state
window.clearBannerState = function() {
  TagBanner.clearBannerState();
  console.log('🔄 Refresh the page to see the banner again');
};

